import {computed,ref,watch,onUpdated} from 'vue'
import {useStore} from 'vuex'
import deBounce from '../../foundation/js/deBounce'
import ProductSpot from '../ProductSpot/ProductSpot.vue'

const buildOverlaySearchUrl = (store, searchString) => {
    const trimmedSearchString = searchString.trim()
    const params = []

    if (trimmedSearchString) {
        params.push(`q=${encodeURIComponent(trimmedSearchString)}`)
    }

    params.push(`take=${store.state.productSearch.default_take}`)
    params.push('skip=0')

    if (store.state.main.lang.isoCode) {
        params.push(`isocode=${encodeURIComponent(store.state.main.lang.isoCode)}`)
    }

    return `${store.state.main.search_page_url}?${params.join('&')}`
}

const searchNow = deBounce((store,searchString)=>{
    store.dispatch('productSearch/resetSelectedFilters')
    if(searchString.length > 2){
        store.dispatch('productSearch/performQuickSearch',{
            searchString: searchString
        })
        return false
    }
    store.commit('productSearch/set_quick_search_results',[])
    store.commit('productSearch/set_quick_search_result_max_count',0)
},400)

export default {
    name: 'SiteNavigationSearchMenu',
    components:{
        ProductSpot
    },
    setup() {
        const store = useStore()
        const showSearchMenu = computed(()=>store.state.main.search_menu_open)
        const results = computed(()=>store.state.productSearch.quick_search_results)
        const totalResultCount = computed(()=>store.state.productSearch.quick_search_result_max_count)
        const searchUrl = computed(()=>buildOverlaySearchUrl(store, searchString.value))
        const searchString = ref('')
        const focusTarget = ref(null)

        const hideSearchMenu = function(){

            store.commit("main/close_search_menu")
            store.commit('main/hide_overlay')
            store.commit('productSearch/set_quick_search_results',[])
            store.commit('productSearch/set_search_string','')
            store.commit('productSearch/set_quick_search_result_max_count',0)
            searchString.value = ''
        }

        const clearSearch = function(){
            store.commit('productSearch/set_search_string','')
            store.commit('productSearch/set_quick_search_result_max_count',0)
            store.commit('productSearch/set_quick_search_results',[])
            store.dispatch('productSearch/resetSelectedFilters'),
            store.dispatch('productSearch/performStringSearch')
            searchString.value = ''
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        const goToSearchPage = () => {
            store.dispatch('productSearch/resetSelectedFilters')
            store.commit('productSearch/set_search_string', searchString.value)
            location.href = buildOverlaySearchUrl(store, searchString.value)
        }

        watch(searchString,(newString)=>{
            searchNow(store,newString)
        })

        watch(showSearchMenu,(isOpen)=>{
            if(isOpen && searchString.value.length >= 2){
                searchNow(store, searchString.value)
            }
        })

        onUpdated(()=>{
            if(showSearchMenu.value) focusTarget.value.focus()
        })

        return {
            showSearchMenu,
            searchString,
            results,
            hideSearchMenu,
            getLabel,
            clearSearch,
            totalResultCount,
            searchUrl,
            goToSearchPage,
            focusTarget
        }
    },
}
